import React, { useState } from "react";

import { Pane } from "clearsense-ui/components";

import CreateReferenceSource from "./CreateReferenceSource";
import ReferenceSourceFormType from "./ReferenceSourceFormType";
import UploadReferenceSource from "./UploadReferenceSource";

const NewReferenceSource = ({
  isPaneOpen,
  setIsPaneOpen,
  fetchReferenceSourcesData,
}) => {
  const [referenceSourceFormType, setReferenceSourceFormType] = useState("");

  const onClose = () => {
    setIsPaneOpen(false);
    setReferenceSourceFormType("");
  };

  return (
    <Pane isOpen={isPaneOpen} onClose={onClose} size="md">
      {referenceSourceFormType === "" && (
        <ReferenceSourceFormType
          onClose={onClose}
          setReferenceSourceFormType={setReferenceSourceFormType}
        />
      )}
      {referenceSourceFormType === "upload" && (
        <UploadReferenceSource
          setIsPaneOpen={setIsPaneOpen}
          onClose={onClose}
          fetchReferenceSourcesData={fetchReferenceSourcesData}
        />
      )}
      {referenceSourceFormType === "new" && (
        <CreateReferenceSource
          onClose={onClose}
          fetchReferenceSourcesData={fetchReferenceSourcesData}
        />
      )}
    </Pane>
  );
};

export default NewReferenceSource;
